// import Template from "./template/Template";
import ProductDetail from "./products/detail/ProductDetail";
import { Switch, Route } from "react-router-dom";
import Landing from "./landing/Landing";
import ProductList from "./products/ProductList";
import { DeleteAccount } from "./template/deleteAccount";
import { PrivacyPolicy } from "./template/PrivacyPolicy";

function App() {
  return (
    // <Template>
      <Switch>
        <Route path="/products" exact>
          <ProductList />
        </Route>
        <Route path="/products/:slug">
          <ProductDetail />
        </Route>
        <Route path="/user/delete">
          <DeleteAccount />
        </Route>
        <Route path="/privacypolicy">
          <PrivacyPolicy />
        </Route>
        <Route path="/" exact>
          <Landing />
        </Route>
      </Switch>
    // </Template>
  );
}

export default App;
